import { observer } from 'mobx-react-lite'
import { Typography } from 'shared/ui'
import { SmartCallActionNode } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/Action/ui/SmartCallActionNode/SmartCallActionNode'
import { type ISmartCallNodeProps } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/SmartCallFlowBuilderUi'
import { useSmartCallFlowBuilderContext } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/context'
import { AITextingAgentStore } from '../../store/AITextingAgentStore'

export const AITextingAgentNode = observer((props: ISmartCallNodeProps) => {
  const { id } = props
  const { getActionById } = useSmartCallFlowBuilderContext()
  const store = getActionById(id)
  if (!(store instanceof AITextingAgentStore)) return null

  const { aiAgent } = store

  return (
    <SmartCallActionNode
      iconProps={AITextingAgentStore.iconProps}
      title={AITextingAgentStore.title}
      placeholder={'Engage with AI Agent'}
      content={
        aiAgent ? (
          <Typography ariaLabel={'aiAgentName'} variant={'body-md-regular'}>
            {aiAgent.name}
          </Typography>
        ) : null
      }
      {...props}
    />
  )
})
